/** Redux Packages. */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const historySlice = createSlice({
    name: 'historyList',
    initialState: initialState,
    reducers: {
        setHistoryList: (state, action) => {
            const { tabValue, data } = action.payload;

            if (!state[tabValue]) {
                state[tabValue] = [];
            }

            data.forEach((newItem) => {
                const idx = state[tabValue].findIndex((item) => item.id === newItem.id);

                if (idx !== -1) {
                    // Update if exists
                    state[tabValue][idx] = newItem;
                } else {
                    // Add if not exists
                    state[tabValue].push(newItem);
                }
            });
        },

        addHistory: (state, action) => {
            const { tabValue, newData } = action.payload;
            if (!state[tabValue]) {
                state[tabValue] = [];
            }
            state[tabValue].push(newData);
        },
    },
});

export const { setHistoryList, addHistory } = historySlice.actions;
export default historySlice.reducer;
